var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
};
import http from "http";
import https from "https";
import { getEnv } from "./env";
export const stringifyList = (list) => {
    return list.map((item) => JSON.stringify(item));
};
/**
 * Camelize object recursively
 * @param obj
 * @returns
 */
export const camelize = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map((item) => camelize(item));
    }
    const camelized = {};
    for (const key in obj) {
        camelized[camelCase(key)] = camelize(obj[key]);
    }
    return camelized;
};
const camelCase = (str) => {
    return str.replace(/([-_][a-z])/gi, ($1) => {
        return $1.toUpperCase().replace('-', '').replace('_', '');
    });
};
function getRequestModule(url) {
    return url.startsWith("https") ? https : http;
}
function streamHttp(url, body, headers) {
    return __asyncGenerator(this, arguments, function* streamHttp_1() {
        var _a, e_1, _b, _c;
        const requestModule = getRequestModule(url);
        function readStream(stream) {
            return __asyncGenerator(this, arguments, function* readStream_1() {
                var _a, e_2, _b, _c;
                const decoder = new TextDecoder();
                try {
                    for (var _d = true, stream_1 = __asyncValues(stream), stream_1_1; stream_1_1 = yield __await(stream_1.next()), _a = stream_1_1.done, !_a; _d = true) {
                        _c = stream_1_1.value;
                        _d = false;
                        const chunk = _c;
                        yield yield __await(decoder.decode(chunk));
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (!_d && !_a && (_b = stream_1.return)) yield __await(_b.call(stream_1));
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            });
        }
        const response = yield __await(new Promise((resolve, reject) => {
            const requestOptions = {
                method: "POST",
                headers: headers,
            };
            const request = requestModule.request(url, requestOptions, resolve);
            request.on("error", reject);
            request.write(body);
            request.end();
        }));
        if (response.statusCode && (response.statusCode < 200 || response.statusCode >= 300)) {
            // assuming the error is a JSON object
            let rawData = "";
            try {
                for (var _d = true, _e = __asyncValues(readStream(response)), _f; _f = yield __await(_e.next()), _a = _f.done, !_a; _d = true) {
                    _c = _f.value;
                    _d = false;
                    const chunk = _c;
                    rawData += chunk;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (!_d && !_a && (_b = _e.return)) yield __await(_b.call(_e));
                }
                finally { if (e_1) throw e_1.error; }
            }
            const message = JSON.parse(rawData);
            throw new Error(message.error || message);
        }
        else {
            yield __await(yield* __asyncDelegator(__asyncValues(readStream(response))));
        }
    });
}
function streamFetch(url, body, headers) {
    return __asyncGenerator(this, arguments, function* streamFetch_1() {
        const response = yield __await(fetch(url, {
            method: 'POST',
            headers: headers,
            body: body,
        }));
        if (!response.ok) {
            // assuming the error is a JSON object
            const message = yield __await(response.json()
            // TODO: test this
            );
            // TODO: test this
            throw new Error(message.error || message);
        }
        // This data is a ReadableStream
        const data = response.body;
        if (!data) {
            return yield __await(void 0);
        }
        const reader = data.getReader();
        const decoder = new TextDecoder();
        let done = false;
        while (!done) {
            const { value, done: doneReading } = yield __await(reader.read());
            done = doneReading;
            const chunkValue = decoder.decode(value);
            yield yield __await(chunkValue);
        }
    });
}
/**
 * Stream data from a URL
 * @param url
 * @param body
 * @param headers
 * @returns
 */
export function stream(url, body, headers) {
    return __asyncGenerator(this, arguments, function* stream_2() {
        if (getEnv() === "node") {
            yield __await(yield* __asyncDelegator(__asyncValues(streamHttp(url, body, headers))));
        }
        else {
            yield __await(yield* __asyncDelegator(__asyncValues(streamFetch(url, body, headers))));
        }
    });
}
export const getFetch = () => {
    if (getEnv() === "node") {
        return require("cross-fetch").default;
    }
    return fetch;
};
export class CustomAsyncGenerator {
    constructor(asyncGenerator) {
        this.generator = asyncGenerator;
    }
    // Standard methods for AsyncIterableIterator
    next() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.generator.next();
        });
    }
    [Symbol.asyncIterator]() {
        return this;
    }
    return(value) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.generator.return(value);
        });
    }
    throw(e) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.generator.throw(e);
        });
    }
    /**
     * **Example**
     * ```ts
     * await generator.map((value) => value + 1)
     * ```
     * @param fn
     * @returns
     */
    map(fn) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = [];
            let iterator = yield this.generator.next();
            while (!iterator.done) {
                result.push(fn(iterator.value));
                iterator = yield this.generator.next();
            }
            return result;
        });
    }
    /**
     * **Example**
     * ```ts
     * const myResults = await generator.get()
     * ```
     * @param fn
     * @returns
     */
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = [];
            let iterator = yield this.generator.next();
            while (!iterator.done) {
                result.push(iterator.value);
                iterator = yield this.generator.next();
            }
            return result;
        });
    }
    /**
     * **Example**
     * ```ts
     * await generator.filter((value) => value > 10)
     * ```
     * @param fn
     * @returns
     */
    filter(fn) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = [];
            let iterator = yield this.generator.next();
            while (!iterator.done) {
                if (fn(iterator.value)) {
                    result.push(iterator.value);
                }
                iterator = yield this.generator.next();
            }
            return result;
        });
    }
    /**
     * **Example**
     * ```ts
     * await generator.forEach((value) => console.log(value))
     * ```
     * @param fn
     * @returns
     */
    forEach(fn) {
        return __awaiter(this, void 0, void 0, function* () {
            let index = 0;
            let iterator = yield this.generator.next();
            while (!iterator.done) {
                fn(iterator.value, index);
                index++;
                iterator = yield this.generator.next();
            }
        });
    }
    /**
     * **Example**
     * ```ts
     * await generator.batch(100).forEach((b) => console.log('do something with batch of 100 here'))
     * ```
     *
     * Returns a CustomAsyncGenerator of batches of size `batchSize`
     * @param batchSize
     * @param fn
     */
    batch(batchSize) {
        return new CustomAsyncGenerator(this.batchGenerator(batchSize));
    }
    batchGenerator(batchSize) {
        return __asyncGenerator(this, arguments, function* batchGenerator_1() {
            let batch = [];
            let iterator = yield __await(this.generator.next());
            while (!iterator.done) {
                batch.push(iterator.value);
                if (batch.length === batchSize) {
                    yield yield __await(batch);
                    batch = [];
                }
                iterator = yield __await(this.generator.next());
            }
            // If there are any leftover items in the batch, yield them as well.
            if (batch.length > 0) {
                yield yield __await(batch);
            }
        });
    }
}
export const batch = (list, fn, size = 100) => __awaiter(void 0, void 0, void 0, function* () {
    const batchSize = size;
    return Promise.all(list
        .reduce((acc, _, i) => {
        if (i % batchSize === 0) {
            acc.push(list.slice(i, i + batchSize));
        }
        return acc;
    }, [])
        .map(fn));
});
//# sourceMappingURL=utils.js.map